import { MenuDownIcon, MenuUpIcon } from '@atgfr8/icons';
import { createEffect, createSignal } from 'solid-js';
import './Styles.css';

export const CautionSelect = (props: {
  label: string;
  value: string | number | null | undefined;
  placeholder: string;
  onChange?: (e: { target: { value: string } }) => void;
  options: { id: number | string; name: string }[];
  disabled?: boolean;
  required?: boolean;
  caution?: boolean;
  error?: string | string[] | null | boolean;
  width?: string;
  resetDirty?: boolean;
}) => {
  const [isDirty, setIsDirty] = createSignal(false);

  const yellowify = () => {
    return props.caution && isDirty();
  };

  createEffect(() => {
    if (props.resetDirty) {
      setIsDirty(false);
    }
  });

  const hasError = () => {
    return (
      props.error !== false &&
      props.error !== null &&
      props.error !== undefined &&
      (Array.isArray(props.error) ? props.error.length > 0 : props.error !== '')
    );
  };

  const getErrorMessage = () => {
    if (!hasError()) return '';
    return Array.isArray(props.error) ? props.error[0] : props.error;
  };

  const handleChange = (e: Event) => {
    const target = e.target as HTMLSelectElement;
    const isEmpty = target.value === '';
    setIsDirty(!isEmpty);
    props.onChange?.({
      target: { value: target.value },
    });
  };

  return (
    <div class={`relative my-1 ${props.width ?? 'w-full'}`}>
      <label
        class={`text-shadow-thick absolute -top-[11px] left-2 px-1 text-sm font-medium z-10 transition-all duration-200 ease-out ${
          hasError()
            ? 'text-[#b00020]'
            : yellowify()
              ? 'text-caution-yellow'
              : 'text-gray-700'
        }`}
      >
        {props.label}
        {props.required && <span class="text-[#b00020]"> *</span>}
      </label>
      <div class="relative">
        <select
          class={`w-full px-3 py-2 pr-10 border rounded-md shadow-xs focus:outline-hidden appearance-none
           disabled:bg-gray-100 disabled:border-gray-300 disabled:text-gray-500 ${
             hasError()
               ? 'bg-white border-[#b00020] focus:border-[#b00020] hover:border-[#b00020]'
               : yellowify()
                 ? 'border-caution-yellow bg-caution-yellow focus:border-caution-yellow hover:border-caution-yellow'
                 : 'bg-white border-[#80b6cf] focus:border-[#123b50] hover:border-[#123b50]'
           }`}
          value={props.value ?? ''}
          onChange={handleChange}
          disabled={props.disabled}
        >
          <option
            value=""
            selected={
              props.value === null ||
              props.value === undefined ||
              props.value === ''
            }
          >
            {props.placeholder}
          </option>
          {props.options.map((option) => (
            <option value={option.id}>{option.name}</option>
          ))}
        </select>
        <MenuDownIcon
          size="18px"
          color={props.disabled ? '#9ca3af' : '#757575'}
          class="select-input-icon select-input-icon--down"
        />
        <MenuUpIcon
          size="18px"
          color={props.disabled ? '#9ca3af' : '#757575'}
          class="select-input-icon select-input-icon--up"
        />
      </div>
      {hasError() && (
        <div class="text-[#b00020] text-xs mt-1 ml-1">{getErrorMessage()}</div>
      )}
    </div>
  );
};
